import React from "react";
import { LinkOffIcon, SettingsIcon } from "@sscs/ui/icons";
import { ActionMenu } from "Components";
import { PERMISSION } from "Constants";
import { PackageSummary } from "Types";

type PackageMenuProps = {
  id: string;
  packageInfo: PackageSummary;
  onEdit: (packageInfo: PackageSummary) => void;
  onDelete: (packageInfo: PackageSummary) => void;
  onConfigureImport: (packageInfo: PackageSummary) => void;
  onDetach: (packageInfo: PackageSummary) => void;
};

const PackageMenu = ({
  id,
  packageInfo,
  onEdit,
  onDelete,
  onConfigureImport,
  onDetach,
}: PackageMenuProps): React.JSX.Element => (
  <ActionMenu
    id={id}
    size="small"
    items={[
      {
        id: "edit-package",
        type: "EDIT",
        text: "Edit package",
        onClick: () => onEdit(packageInfo),
        permissions: [PERMISSION.CREATE_PACKAGE],
      },
      ...(packageInfo.external_catalog
        ? [
            {
              id: "configure-import",
              type: "CUSTOM" as const,
              itemIcon: <SettingsIcon />,
              text: `Configure ${packageInfo.external_catalog.catalog_display_name} catalog import`,
              onClick: () => onConfigureImport(packageInfo),
              permissions: [PERMISSION.CREATE_PACKAGE],
            },
            {
              id: "detach-from-catalog",
              type: "CUSTOM" as const,
              itemIcon: <LinkOffIcon />,
              text: `Detach from ${packageInfo.external_catalog.catalog_display_name} catalog`,
              onClick: () => onDetach(packageInfo),
              permissions: [PERMISSION.CREATE_PACKAGE],
            },
          ]
        : []),
      {
        id: "delete-package",
        type: "DELETE",
        text: "Delete package",
        onClick: () => onDelete(packageInfo),
        permissions: [PERMISSION.DELETE_PACKAGE],
      },
    ]}
  />
);

export default PackageMenu;
